module.exports = __webpack_public_path__ + "static/img/10.ef937cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/6/eng/10.png
// module id = J+PW
// module chunks = 0